import React, { memo } from 'react';
import {
  PrintSingleTaskConsumer,
  IPrintSingleTaskContext,
} from 'store/context/PrintSingleTaskContext';

import messages from './Messages';
import { IPrintPartProps } from 'store/entity/IPrintTemplatePart';

const SubTasksTitlePart: React.FC<IPrintPartProps<'subTasksTitle'>> = ({
  item,
  taskId,
}) => (
  <PrintSingleTaskConsumer>
    {(dataContext: IPrintSingleTaskContext) => {
      const { allTasks } = dataContext;
      const parentTaskId = allTasks!.find((t) => t.id === taskId)!.parentId;
      const subTasksTitle = allTasks!.find((t) => t.id === parentTaskId)![
        item.part
      ];

      return <span>{messages.getSubTasksTitle(subTasksTitle)}</span>;
    }}
  </PrintSingleTaskConsumer>
);

export default memo(SubTasksTitlePart);
